import { css } from 'styled-components';

export const gradient = css`
  background:
    linear-gradient(
      62deg,
      ${({ theme }) => theme.colors.gradient.neutral_dark},
      ${({ theme }) => theme.colors.gradient.neutral_light}
    ),
    radial-gradient(
      circle at 5% 15%,
      ${({ theme }) => theme.colors.gradient.light},
      transparent 30%
    ),
    radial-gradient(
      circle at 110% 8%,
      ${({ theme }) => theme.colors.gradient.dark},
      transparent 40%
    ),
    radial-gradient(
      ellipse at 0% 100%,
      ${({ theme }) => theme.colors.gradient.dark},
      transparent 50%
    );
  background-blend-mode: soft-light;
`;
